import { CustomerAddress } from '../../../types/customers';
import { Customer } from '../../types';

export enum ActionTypes {
    OpenEditModal = '[customer/addresses] OPEN_EDIT_MODAL',
    CloseEditModal = '[customers/addresses] CLOSE_EDIT_MODAL',
    OpenAddModal = '[customers/addresses] OPEN_ADD_MODAL',
    CloseAddModal = '[customers/addresses] CLOSE_ADD_MODAL',
    EditCustomerAddresses = '[customer/addresses] EDIT_CUSTOMER_ADDRESSES',
    FetchEditCustomerAddressesResponse = '[customer/addresses] FETCH_EDIT_CUSTOMER_ADRESSES_RESPONSE',
    AddCustomerAddresses = '[customer/addresses] ADD_CUSTOMER_ADDRESSES',
    FetchAddCustomerAddressesResponse = '[customer/addresses] FETCH_ADD_CUSTOMER_ADRESSES_RESPONSE',
}

export interface OpenEditModal {
    type: ActionTypes.OpenEditModal;
    payload: {
        index: number;
    };
}

export interface CloseEditModal {
    type: ActionTypes.CloseEditModal;
}

export interface OpenAddModal {
    type: ActionTypes.OpenAddModal;
}

export interface CloseAddModal {
    type: ActionTypes.CloseAddModal;
}

export interface EditCustomerAddresses {
    type: ActionTypes.EditCustomerAddresses;
    payload: {
        accountId: string;
        id: string;
        addresses: CustomerAddress[];
    };
}

export interface FetchEditCustomerAddressesResponse {
    type: ActionTypes.FetchEditCustomerAddressesResponse;
    payload: {
        customer: Customer;
    };
    meta: {
        cause: EditCustomerAddresses;
    };
}

export interface AddCustomerAddresses {
    type: ActionTypes.AddCustomerAddresses;
    payload: {
        accountId: string;
        id: string;
        addresses: CustomerAddress[];
    };
}

export interface FetchAddCustomerAddressesResponse {
    type: ActionTypes.FetchAddCustomerAddressesResponse;
    payload: {
        customer: Customer;
    };
    meta: {
        cause: AddCustomerAddresses;
    };
}

export function openEditModal(index: number) {
    return {
        type: ActionTypes.OpenEditModal,
        payload: {
            index,
        },
    };
}

export function closeEditModal() {
    return {
        type: ActionTypes.CloseEditModal,
    };
}

export function openAddModal() {
    return {
        type: ActionTypes.OpenAddModal,
    };
}

export function closeAddModal() {
    return {
        type: ActionTypes.CloseAddModal,
    };
}

export function editCustomerAddresses(
    accountId: string,
    id: string,
    addresses: CustomerAddress[]
): EditCustomerAddresses {
    return {
        type: ActionTypes.EditCustomerAddresses,
        payload: {
            accountId,
            id,
            addresses,
        },
    };
}

export function addCustomerAddresses(
    accountId: string,
    id: string,
    addresses: CustomerAddress[]
): AddCustomerAddresses {
    return {
        type: ActionTypes.AddCustomerAddresses,
        payload: {
            accountId,
            id,
            addresses,
        },
    };
}

export type Actions =
    | OpenEditModal
    | CloseEditModal
    | OpenAddModal
    | CloseAddModal
    | EditCustomerAddresses
    | FetchEditCustomerAddressesResponse
    | AddCustomerAddresses
    | FetchAddCustomerAddressesResponse;
